import EnvironmentConfiguration from "./EnvironmentConfiguration";
import LeadResultType from "./LeadResultType";

/** A mapping from a {@link LeadResultType} to its display label. */
const LeadResultTypeLabelMask = {
  [EnvironmentConfiguration.leadResultIds[LeadResultType.BadLead]]: "Bad Lead",
  [EnvironmentConfiguration.leadResultIds[LeadResultType.Booked]]: "Booked",
  [EnvironmentConfiguration.leadResultIds[LeadResultType.ExistingPatient]]: "Existing Patient",
  [EnvironmentConfiguration.leadResultIds[LeadResultType.OtherProcedures]]: "Other Procedures",
  [EnvironmentConfiguration.leadResultIds[LeadResultType.NotReached]]: "Not Reached",
  [EnvironmentConfiguration.leadResultIds[LeadResultType.MedicalEscalation]]: "Medical Escalation",
  [EnvironmentConfiguration.leadResultIds[LeadResultType.DoNotCall]]: "Do Not Call",
  [EnvironmentConfiguration.leadResultIds[LeadResultType.DroppedChat]]: "Dropped Chat"
};

export default LeadResultTypeLabelMask;
